import { render, staticRenderFns } from "./MountingRailsTable.vue?vue&type=template&id=1ec561fd"
import script from "./MountingRailsTable.vue?vue&type=script&lang=js"
export * from "./MountingRailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports